import React from 'react';
import { ShieldCheck, Star, Lock } from 'lucide-react';
export function TrustFooter() {
  return <footer className="fixed bottom-[44px] sm:bottom-[52px] left-0 right-0 z-40 w-full bg-white border-t border-gray-200 py-1.5 sm:py-3" data-id="element-214">
      <div className="max-w-4xl mx-auto px-4" data-id="element-215">
        <div className="flex items-center justify-center gap-4 sm:gap-10 text-gray-500" data-id="element-216">
          <div className="flex items-center gap-1.5" data-id="element-217">
            <div className="bg-blue-50 p-1.5 rounded-full" data-id="element-218">
              <ShieldCheck className="w-4 h-4 text-primary" data-id="element-219" />
            </div>
            <div className="flex flex-col" data-id="element-220">
              <span className="text-[10px] font-bold text-gray-700" data-id="element-221">BBB</span>
              <span className="text-[10px] font-semibold text-primary" data-id="element-222">A+</span>
            </div>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-223">
            <div className="bg-green-50 p-1.5 rounded-full" data-id="element-224">
              <Star className="w-4 h-4 text-green-500 fill-green-500" data-id="element-225" />
            </div>
            <div className="flex flex-col" data-id="element-226">
              <span className="text-[10px] font-bold text-gray-700" data-id="element-227">
                Trustpilot
              </span>
              <span className="text-[10px] font-semibold text-green-600" data-id="element-228">
                4.8/5.0
              </span>
            </div>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-229">
            <div className="bg-gray-100 p-1.5 rounded-full" data-id="element-230">
              <Lock className="w-4 h-4 text-gray-600" data-id="element-231" />
            </div>
            <div className="flex flex-col" data-id="element-232">
              <span className="text-[10px] font-bold text-gray-700" data-id="element-233">SSL</span>
              <span className="text-[10px]" data-id="element-234">256-bit</span>
            </div>
          </div>
        </div>
        <p className="hidden sm:block text-center text-[10px] text-gray-400 mt-2" data-id="element-235">
          Tu información está protegida con cifrado de 256 bits.
        </p>
      </div>
    </footer>;
}